// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_NonEmpty = require("relude/src/Relude_NonEmpty.bs.js");
var Relude_List_Specializations = require("relude/src/list/Relude_List_Specializations.bs.js");

function arrPure(pos, err) {
  return {
          TAG: /* Arr */2,
          _0: Relude_NonEmpty.List.pure([
                pos,
                err
              ])
        };
}

function objPure(field, err) {
  return {
          TAG: /* Obj */3,
          _0: Relude_NonEmpty.List.pure([
                field,
                err
              ])
        };
}

function combine(a, b) {
  switch (a.TAG | 0) {
    case /* Val */0 :
        return a;
    case /* TriedMultiple */1 :
        return {
                TAG: /* TriedMultiple */1,
                _0: Relude_NonEmpty.List.concat(a._0, Relude_NonEmpty.List.pure(b))
              };
    case /* Arr */2 :
        if (b.TAG === /* Arr */2) {
          return {
                  TAG: /* Arr */2,
                  _0: Relude_NonEmpty.List.concat(a._0, b._0)
                };
        } else {
          return a;
        }
    case /* Obj */3 :
        if (b.TAG === /* Obj */3) {
          return {
                  TAG: /* Obj */3,
                  _0: Relude_NonEmpty.List.concat(a._0, b._0)
                };
        } else {
          return a;
        }
    
  }
}

function makeTriedMultiple(x) {
  if (x.TAG === /* TriedMultiple */1) {
    return x;
  } else {
    return {
            TAG: /* TriedMultiple */1,
            _0: Relude_NonEmpty.List.pure(x)
          };
  }
}

function failureToPartialString(param) {
  if (typeof param === "string") {
    if (param === "ExpectedObject") {
      return "Expected object";
    } else if (param === "ExpectedNumber") {
      return "Expected number";
    } else if (param === "ExpectedArray") {
      return "Expected array";
    } else if (param === "ExpectedInt") {
      return "Expected int";
    } else if (param === "ExpectedValidOption") {
      return "Expected a valid option";
    } else if (param === "ExpectedValidDate") {
      return "Expected a valid date";
    } else if (param === "ExpectedBoolean") {
      return "Expected boolean";
    } else {
      return "Expected string";
    }
  } else {
    return "Expected tuple of size " + Relude_Int.toString(param.VAL);
  }
}

function failureToString(v, json) {
  return failureToPartialString(v) + (" but found " + JSON.stringify(json));
}

function toDebugString(levelOpt, preOpt, innerToString, v) {
  var level = levelOpt !== undefined ? levelOpt : 0;
  var pre = preOpt !== undefined ? preOpt : "";
  var spaces = function (indent) {
    return Relude_String.repeat((indent << 2), " ");
  };
  var msg;
  switch (v.TAG | 0) {
    case /* Val */0 :
        msg = Curry._2(innerToString, v._0, v._1);
        break;
    case /* TriedMultiple */1 :
        var partial_arg = level + 1 | 0;
        var childMessages = Curry._2(Relude_List_Specializations.$$String.joinWith, "\n", Relude_NonEmpty.List.toSequence(Relude_NonEmpty.List.map((function (param) {
                        return toDebugString(partial_arg, undefined, innerToString, param);
                      }), v._0)));
        msg = "Attempted multiple decoders, which all failed:\n" + childMessages;
        break;
    case /* Arr */2 :
        var childMessages$1 = Curry._2(Relude_List_Specializations.$$String.joinWith, "\n", Relude_NonEmpty.List.toSequence(Relude_NonEmpty.List.map((function (param) {
                        return toDebugString(level + 1 | 0, "At position " + (String(param[0]) + ": "), innerToString, param[1]);
                      }), v._0)));
        msg = "Failed to decode array:\n" + childMessages$1;
        break;
    case /* Obj */3 :
        var childMessages$2 = Curry._2(Relude_List_Specializations.$$String.joinWith, "\n", Relude_NonEmpty.List.toSequence(Relude_NonEmpty.List.map((function (param) {
                        var err = param[1];
                        var fieldStr = "\"" + (param[0] + "\"");
                        if (err) {
                          return toDebugString(level + 1 | 0, "Field " + (fieldStr + " had an invalid value: "), innerToString, err._0);
                        } else {
                          return spaces(level + 1 | 0) + ("Field " + (fieldStr + " is required, but was not present"));
                        }
                      }), v._0)));
        msg = "Failed to decode object:\n" + childMessages$2;
        break;
    
  }
  return spaces(level) + (pre + msg);
}

function failureToDebugString(err) {
  return toDebugString(undefined, undefined, failureToString, err);
}

function ResultOf(Err) {
  var apply = function (f, v) {
    if (f.TAG === /* Ok */0) {
      if (v.TAG === /* Ok */0) {
        return Relude_Result.ok(Curry._1(f._0, v._0));
      } else {
        return v;
      }
    } else if (v.TAG === /* Ok */0) {
      return f;
    } else {
      return Relude_Result.error(combine(f._0, v._0));
    }
  };
  var valErr = function (v, json) {
    return Relude_Result.error({
                TAG: /* Val */0,
                _0: Curry._1(Err.handle, v),
                _1: json
              });
  };
  var arrErr = function (pos) {
    return Curry._1(Relude_Result.mapError, (function (param) {
                  return arrPure(pos, param);
                }));
  };
  var missingFieldErr = function (field) {
    return Relude_Result.error(objPure(field, /* MissingField */0));
  };
  var objErr = function (field) {
    return Curry._1(Relude_Result.mapError, (function (x) {
                  return objPure(field, /* InvalidField */{
                              _0: x
                            });
                }));
  };
  var lazyAlt = function (res, fn) {
    if (res.TAG === /* Ok */0) {
      return res;
    }
    var err = makeTriedMultiple(res._0);
    return Curry._2(Relude_Result.mapError, (function (param) {
                  return combine(err, param);
                }), Curry._1(fn, undefined));
  };
  var TransformError = {
    valErr: valErr,
    arrErr: arrErr,
    missingFieldErr: missingFieldErr,
    objErr: objErr,
    lazyAlt: lazyAlt
  };
  return {
          map: Relude_Result.map,
          apply: apply,
          pure: Relude_Result.pure,
          flat_map: Relude_Result.bind,
          TransformError: TransformError
        };
}

exports.arrPure = arrPure;
exports.objPure = objPure;
exports.combine = combine;
exports.failureToString = failureToString;
exports.toDebugString = toDebugString;
exports.failureToDebugString = failureToDebugString;
exports.ResultOf = ResultOf;
/* Relude_Int Not a pure module */
